module.exports = __webpack_public_path__ + "media/images/icons/key-a549ef79d7810c2eb78cf64a2e2c5111.svg";